import React, { useEffect, useRef, useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import JoditEditor from "jodit-react";
import { configJodit } from "../../screens/redux/api/Constants";
import { toast } from "react-toastify";
import { useLazyPropertyContentListQuery } from "../../screens/redux/api/api";

const DescriptionAdd = ({ formData, setFormData }) => {
  const editorCondition = useRef([]);
  const imgRef = useRef();

  // State for lists
  const [cancelList, setCancelList] = useState([]);
  const [safetyList, setSafetyList] = useState([]);
  const [rulesList, setRulesList] = useState([]);
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [draggedItem, setDraggedItem] = useState(null);

  // RTK Query
  const [propertyContentListApi] = useLazyPropertyContentListQuery();

  // Fetch policy lists
  const getList = () => {
    propertyContentListApi()
      .unwrap()
      .then((res) => {
        // const cancel = res?.data?.find(item => item.name === "Cancellation Policy")?.descriptions   || [];
        // const rules = res?.data?.find(item => item.name === "House Rules")?.descriptions || [];
        // const safety = res?.data?.find(item => item.name === "Safety & Property")?.descriptions || [];
        const cancel = res?.data?.filter((item) => item?.policy_type == 1);
        console.log('cancel', cancel);

        setCancelList(cancel);

        const rules = res?.data?.filter((item) => item?.policy_type == 2);
        setRulesList(rules);

        const safety = res?.data?.filter((item) => item?.policy_type == 3);
        setSafetyList(safety);
        // setCancelList(cancel);
        // setRulesList(rules);
        // setSafetyList(safety);
      })
      .catch(console.error);
  };

  // Handle image upload
  const handleImages = (e) => {
    const files = Array.from(e.target.files || []);
    if (formData.property_images.length + files.length > 10) {
      toast.error("Maximum 10 images allowed");
      return;
    }


    const newImages = files.map(file => ({
      file,
      preview: file
    }));

    setFormData(prev => ({
      ...prev,
      property_images: [...prev.property_images, ...newImages]
    }));
  };

  // Remove image
  const removeImage = (index) => {
    setFormData(prev => ({
      ...prev,
      property_images: prev.property_images.filter((_, i) => i !== index)
    }));
  };

  // Drag and drop handlers
  const handleDragStart = (e, index) => {
    setDraggedItem(index);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/html", e.currentTarget);
  };

  const handleDragOver = (index) => {
    if (draggedItem === null || draggedItem === index) return;
    setFormData(prev => {
      const newImages = [...prev.property_images];
      const draggedImage = newImages[draggedItem];
      newImages.splice(draggedItem, 1);
      newImages.splice(index, 0, draggedImage);
      return { ...prev, property_images: newImages };
    });
    setDraggedItem(index);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
  };

  // Handle additional descriptions
  const handleDescription = (ind, field, value) => {
    setFormData(prev => {
      const newAdditionalDetails = [...prev.additional_details];
      newAdditionalDetails[ind] = {
        ...newAdditionalDetails[ind],
        [field]: value
      };
      return { ...prev, additional_details: newAdditionalDetails };
    });
  };

  const addDescriptionField = () => {
    if (formData.additional_details.length < 3) {
      setFormData(prev => ({
        ...prev,
        additional_details: [...prev.additional_details, { title: "", value: "" }]
      }));
    }
  };

  console.log('images_preview', imagePreview)

  const removeDescriptionField = (ind) => {
    if (ind > 0) {
      setFormData(prev => ({
        ...prev,
        additional_details: prev.additional_details.filter((_, i) => i !== ind)
      }));
    }
  };

  // Show image preview
  const previewImage = (img) => {
    setImagePreview(img.preview);
    setShowImagePopup(true);
  };



  // Fetch lists on mount
  useEffect(() => {
    getList();
  }, [])

  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  return (
    <div className="mt-4">
      {/* Cancellation Policy Section */}
      <div>
        <div className="d-flex ac-jb mb-3">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
            Cancellation Policy
          </h4>
          <select
            className="input-pop ps-2 mx-3 w-50"
            onChange={(e) => setFormData(prev => ({ ...prev, cancellation_policy: e.target.value }))}
            value={formData.cancellation_policy}
          >
            <option value="">Select Policy</option>
            {cancelList.map((item) => (
              <option key={item.id} value={item.description}>
                {item.description.length > 32
                  ? `${stripHtml(item.description).substring(0, 32)}...`
                  : <p>{stripHtml(item.description)}</p>}
              </option>
            ))}
            {console.log("datas", cancelList)}
          </select>
        </div>
        <JoditEditor
          value={formData.cancellation_policy}
          config={configJodit}
          onBlur={(content) => setFormData(prev => ({ ...prev, cancellation_policy: content }))}
          className="input-pop w-100"
          style={{ border: "1px solid #0C3A2D" }}
        />
      </div>

      {/* House Rules Section */}
      <div className="mt-4">
        <div className="d-flex ac-jb mb-3">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
            House Rules
          </h4>
          <select
            className="input-pop ps-2 mx-3 w-50"
            onChange={(e) => setFormData(prev => ({ ...prev, house_rules: e.target.value }))}
            value={formData.house_rules}
          >
            <option value="">Select Rules</option>
            {rulesList.map((item) => (
              <option key={item.id} value={item.description}>
                {item.description.length > 32
                  ? `${stripHtml(item.description).substring(0, 32)}...`
                  : <p>{stripHtml(item.description)}</p>}
              </option>
            ))}
          </select>
        </div>
        <JoditEditor
          value={formData.house_rules}
          config={configJodit}
          onBlur={(content) => setFormData(prev => ({ ...prev, house_rules: content }))}
          className="input-pop w-100"
          style={{ border: "1px solid #0C3A2D" }}
        />
      </div>

      {/* Safety & Property Section */}
      <div className="mt-4">
        <div className="d-flex ac-jb mb-3">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
            Other Policies
          </h4>
          <select
            className="input-pop ps-2 mx-3 w-50"
            onChange={(e) => setFormData(prev => ({ ...prev, safety_property: e.target.value }))}
            value={formData.safety_property}
          >
            <option value="">Select Safety Info</option>
            {safetyList.map((item) => (
              <option key={item.id} value={item.description}>
                {item.description.length > 32
                  ? `${stripHtml(item.description).substring(0, 32)}...`
                  : <p>{stripHtml(item.description)}</p>}
              </option>
            ))}
          </select>
        </div>
        <JoditEditor
          value={formData.safety_property}
          config={configJodit}
          onBlur={(content) => setFormData(prev => ({ ...prev, safety_property: content }))}
          className="input-pop w-100"
          style={{ border: "1px solid #0C3A2D" }}
        />
      </div>

      {/* Additional Descriptions */}
      <div className="mt-4">
        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
          Additional Details
        </h4>
        {formData.additional_details.map((item, ind) => (
          <div key={ind} className="mt-3">
            <div className="d-flex ac-jb">
              <input
                type="text"
                className="input-pop ps-2 col-md-4 mb-3"
                placeholder="Title"
                value={item.title}
                onChange={(e) => handleDescription(ind, "title", e.target.value)}
              />
              {ind > 0 && (
                <CancelIcon
                  className="text-danger mb-3 pointer"
                  onClick={() => removeDescriptionField(ind)}
                />
              )}
            </div>
            <JoditEditor
              ref={(el) => (editorCondition.current[ind] = el)}
              value={item.value}
              config={configJodit}
              onBlur={(content) => handleDescription(ind, "value", content)}
              className="input-pop w-100"
              style={{ border: "1px solid #0C3A2D" }}
            />
          </div>
        ))}
        {formData.additional_details.length < 3 && (
          <button
            className="cust-btn recep-yes mt-3"
            onClick={addDescriptionField}
          >
            Add
          </button>
        )}
      </div>

      {/* Image Upload Section */}
      <div className="mt-4">
        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
          Property Images (Max 10) (4853x3235 px)
        </h4>
        <div className="d-flex flex-wrap gap-3">
          <button
            className="cust-btn recep-yes"
            onClick={() => imgRef.current.click()}
            disabled={formData.property_images.length >= 10}
          >
            Upload
          </button>
          <input
            type="file"
            ref={imgRef}
            onChange={handleImages}
            accept="image/*"
            multiple
            className="d-none"
          />
          <div className="d-flex flex-wrap gap-2 mt-2">
            {formData.property_images.map((img, index) => (
              <div
                key={index}
                className="position-relative"
                draggable
                onDragStart={(e) => handleDragStart(e, index)}
                onDragOver={() => handleDragOver(index)}
                onDragEnd={handleDragEnd}
                style={{
                  opacity: draggedItem === index ? 0.5 : 1,
                  cursor: 'move'
                }}
              >
                <img
                  src={img.preview?.name ? URL.createObjectURL(img?.preview) : img?.preview}
                  alt="Preview"
                  className="img-thumbnail"
                  style={{ width: "100px", height: "100px", cursor: "pointer" }}
                  onClick={() => previewImage(img)}
                />
                <CancelIcon
                  className="position-absolute top-0 end-0 bg-white rounded-circle"
                  style={{ transform: "translate(30%, -30%)", cursor: "pointer" }}
                  onClick={() => removeImage(index)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Image Preview Modal */}
      {showImagePopup && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.7)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div className="modal-content" style={{
            position: 'relative',
            maxWidth: '90vw',
            maxHeight: '90vh'
          }}>
            <button
              className="close-button"
              onClick={() => setShowImagePopup(false)}
              style={{
                position: 'absolute',
                top: '-15px',
                right: '-15px',
                background: 'white',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: 'none',
                cursor: 'pointer',
                zIndex: 1001
              }}
            >
              <CancelIcon style={{ color: 'red', fontSize: '20px' }} />
            </button>
            <img
              src={imagePreview.name ? URL.createObjectURL(imagePreview) : imagePreview}
              alt="Full Preview"
              style={{
                maxWidth: '100%',
                maxHeight: '90vh',
                display: 'block',
                margin: '0 auto'
              }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default DescriptionAdd;